import React from 'react';
import { Box, VStack, Text, Spinner, Center } from '@chakra-ui/react';

interface LoaderProps {
    text?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    background?: string;
}

const Loader: React.FC<LoaderProps> = ({ text, size = 'md', background = 'transparent' }) => {
    return (
        <Box bg={background} display="flex" alignItems="center" justifyContent="center" w="full" h="full">
            <Center>
                <VStack gap={4}>
                    <Spinner size={size} color="yellow.600" />
                    {text && (
                        <Text fontSize="md" color="gray.600" textAlign="center">
                            {text}
                        </Text>
                    )}
                </VStack>
            </Center>
        </Box>
    );
};

export default Loader;
